import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Tag } from './tag.model';

export interface TagRepository {
  selectAll(): Observable<Tag[]>;
  create(tag: Omit<Tag, 'id' | 'isSystem'>): Observable<Tag>;
  update(tag: Tag): Observable<Tag>;
  delete(id: string): Observable<void>;
}

export const TAG_REPOSITORY = new InjectionToken<TagRepository>('TAG_REPOSITORY');
